<section class="wrap-diferentials">
  <div class="layout">
    <div class="box">
      <div
        class="figure"
        style="
          background: url(https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Grupo-de-mascara-28.png);
        "
      ></div>
      <div class="content">
        <h2 class="subtitle">Diferenciais</h2>

        <div class="list-diferencials">
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/homologado@2x.png"
                alt="Sistemas homologados"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>Sistemas homologados;</p>
            </div>
          </div>
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/network@2x.png"
                alt="Rede de empresas"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>
                Extensa carteira de empresas, clientes, distribuidores e cias;
              </p>
            </div>
          </div>
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/software@2x.png"
                alt="Softwares próprios"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>
                Itens de alimentação, softwares, ferramentas e produtos
                próprios;
              </p>
            </div>
          </div>
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/online@2x.png"
                alt="Base online"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>
                BASE ONLINE com os dados mais confiáveis do mercado. Você
                atualizado e sem surpresas lá na frente!
              </p>
            </div>
          </div>
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Grupo-883@2x.png"
                alt="Decisão Certa"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>
                Decisão Certa: a mais completa do mercado - tudo que precisa
                personalizado para a sua empresa;
              </p>
            </div>
          </div>
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/brasil@2x.png"
                alt="Atendimento em todo Brasil"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>
                Atendimento nas mais diversas regiões do Brasil (Território
                Nacional);
              </p>
            </div>
          </div>
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Grupo-979@2x.png"
                alt="Empresas certificadas"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>
                Empresas certificadas no grupo com mais de 15 anos de atuação;
              </p>
            </div>
          </div>
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/secure@2x.png"
                alt="Acessos oficiais"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>Acessos oficiais;</p>
            </div>
          </div>
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/contract@2x.png"
                alt="Melhores políticas comerciais"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>Melhores políticas de qualidade e condições comerciais;</p>
            </div>
          </div>
          <div class="diferencial">
            <div class="icon">
              <img
                src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/tempo@2x.png"
                alt="Menor tempo de resposta"
                loading="lazy"
              />
            </div>
            <div class="text">
              <p>Menor tempo de resposta;</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="wrap-diferentials alvesp">
  <div class="layout" style="align-items: center">
    <div class="box">
      <a href="https://unionsolutions.com.br/gestao/parceria-alvesp/">
        <img
          class="img-alvessp-desktop"
          src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2023/09/Parceria-entre-a-Union-Solutions-e-ALVESP-oferece-beneficios-aos-associados-1.png"
          alt="Parceria AlvesSp"
          width="100%"
          loading="lazy"
        />
        <!-- <img class="img-alvessp-mobile"
          src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2023/09/Parceria-entre-a-Union-Solutions-e-ALVESP-oferece-beneficios-aos-associados-400-×-600-px-1.png"
          alt="Parceria AlvesSp" width="100%"> -->
      </a>
    </div>
  </div>
</section>
